// @flow

import { ServiceUnavailable } from "@modules/app/constants/actions";
import { cloneObject } from "@utils/object";

export type AppState = $Exact<{
  serviceUnavailable: boolean | string,
}>;

export const initialState: AppState = {
  serviceUnavailable: false,
};

export const onServiceUnavailable = (state: AppState) => ({ payload }: Object) => {
  return { ...state, error: null, serviceUnavailable: payload };
};

export default (state: AppState = initialState, action: Object) => {
  const act = {
    [ServiceUnavailable]: onServiceUnavailable,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
